import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ tema: 'vilagos', temaValtas: () => {} });

export function ThemeProvider({ children }) {
  const [tema, setTema] = useState(() => {
    try {
      return localStorage.getItem('netokos-tema') || 'vilagos';
    } catch {
      return 'vilagos';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-tema', tema);
    try {
      localStorage.setItem('netokos-tema', tema);
    } catch {
      // localStorage nem elérhető - nem gond, csak nem marad meg a választás
    }
  }, [tema]);

  const temaValtas = () => setTema(t => (t === 'vilagos' ? 'sotet' : 'vilagos'));

  return (
    <ThemeContext.Provider value={{ tema, temaValtas }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTema() {
  return useContext(ThemeContext);
}